import { Component, Input, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { SocialButtonConfig, ShareParams, ShareType } from 'src/app/models/social';
import { IconButtonType } from '../icon-button/icon-button.component';

@Component({
  selector: 'app-social-button',
  templateUrl: './social-button.component.html',
  styleUrls: ['./social-button.component.scss'],
})
export class SocialButtonComponent implements OnInit {
  @Input()
  config: SocialButtonConfig;

  @Input()
  url: string;

  @Input()
  title: string;

  @Input()
  description: string;

  @Input()
  image: string;

  @Input()
  tags: string;

  @Input()
  popupWidthPx: 600;

  @Input()
  popupHeighPx: 600;

  @Input()
  location: IconButtonType = 'RECORD';

  constructor(private meta: Meta) {}

  ngOnInit() {}

  share() {
    if (this.config) {
      const params = this.buildCompleteParams();
      const finalUrl = this.config.shareLinks.generic + this.serializeParams(params);
      window.open(finalUrl, '_blank', `width=${this.popupWidthPx}, height=${this.popupHeighPx}, noopener`);
    }
  }

  private serializeParams(values: ShareParams) {
    return Object.entries(this.config.paramKeys)
      .map(([k, v]) => {
        let paramValue = values[k];

        if (k === 'description') {
          paramValue = this.buildCompleteDescription(values);
        }

        return paramValue ? `${v}=${encodeURIComponent(paramValue)}` : '';
      })
      .filter((p) => p !== '')
      .join('&');
  }

  private buildCompleteDescription(p: ShareParams) {
    if (ShareType.WHATSAPP === this.config.type || ShareType.EMAIL === this.config.type) {
      return p.description ? `${p.description}\r\n${p.url}` : p.url;
    }
    return p.description;
  }

  private buildCompleteParams(): ShareParams {
    return {
      url: this.url || window.location.href,
      title: this.title || this.getMetaTagContent('og:title'),
      description: this.description || this.getMetaTagContent('og:description'),
      image: this.image || this.getMetaTagContent('og:image'),
      tags: this.tags,
      appId: this.getMetaTagContent('fb:app_id'),
      redirectUrl: this.url,
    };
  }

  private getMetaTagContent(key: string): string {
    const metaUsingProperty: HTMLMetaElement = this.meta.getTag(`property="${key}"`);
    if (metaUsingProperty) {
      return metaUsingProperty.getAttribute('content');
    }
    const metaUsingName: HTMLMetaElement = this.meta.getTag(`name="${key}"`);
    if (metaUsingName) {
      return metaUsingName.getAttribute('content');
    }
  }
}
